import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import './_saldoBox.scss'

function SaldoBox() {
    const navigate = useNavigate()
    const [isOpen, setIsOpen] = useState(false)
    const selectorUser = useSelector((user) => user.user)
    const totaleConsumi = selectorUser.totaleConsumi
    const totaleOneri = selectorUser.totaleOneri
    const ultimoSaldo = selectorUser.ultimoSaldo
    const totaleSaldo = selectorUser.totaleSaldo
  return (
    <motion.header
      initial={false}
      onClick={() => setIsOpen(isOpen ? false : true)}
      className="whatsInside" 
    >
      <div className="whatsHeader">
        <motion.p
          className="bold"
          initial={false}
          animate={isOpen ? "collapsed" : "open"}
          variants={{
            open: { transform: "scale(1)" },
            collapsed: { transform: "scale(0.9)" },
          }}
          transition={{ duration: 0.5 }}
        >
          Cosa contiene il mio saldo?
        </motion.p>
        <motion.div
          initial={false}
          animate={isOpen ? "collapsed" : "open"}
          variants={{
            open: { transform: "rotate(180deg)" },
            collapsed: { transform: "rotate(0deg)" },
          }}
          transition={{ duration: 0.5 }}
        >
          <ExpandLessIcon />
        </motion.div>
      </div>
      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.section
            className="headerCollapse"
            key="content"
            initial="collapsed"
            animate="open"
            exit="collapsed"
            variants={{
              open: { opacity: 1, height: "auto" },
              collapsed: { opacity: 0, height: 0 },
            }}
            transition={{ duration: 0.5, ease: [0.04, 0.62, 0.23, 0.98] }}
          >
            <>
              <motion.div
                className="items"
                initial="collapsed"
                animate="open"
                exit="collapsed"
                variants={{
                  open: { opacity: 1 },
                  collapsed: { opacity: 0 },
                }}
                transition={{ duration: 0.2 }}
              >
                <div className="item">
                  <p className="title">Consumi</p>
                  <p className="number">{totaleConsumi} €</p>
                </div>
                <div className="item">
                  <p className="title">Altri oneri</p>
                  <p className="number">{totaleOneri} €</p>
                </div>
                <div className="item">
                  <p className="title">Credito iniziale</p>
                  <p className="number">{ultimoSaldo} €</p>
                </div>
                <div className="line"></div>
                <div className={`item ${parseFloat(totaleSaldo) > 0 ? "green" : "red"}`}>
                  <p className="title">Totale saldo</p>
                  <p className="number">{totaleSaldo} €</p>
                </div>
              </motion.div>
              <div
                className="goMovements"
                onClick={() => navigate("/enrica/movimenti")}
              >
                <p>Guarda tutti i movimenti</p>
                <ArrowForwardIosIcon />
              </div>
            </>
          </motion.section>
        )}
      </AnimatePresence>
    </motion.header>
  );
}

export default SaldoBox;
